import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Lock, Mail, ArrowRight } from 'lucide-react';
import Layout from '../components/Layout';
import SafeImage from '../components/SafeImage';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout hideFooter>
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="neon-card rounded-lg p-8 relative">
          <div className="flex flex-col items-center mb-6">
            <div className="w-14 h-14 mb-3 grid place-items-center rounded border border-orange-500/60 bg-orange-500/10 overflow-hidden">
              <SafeImage src="/valorex-logo.png" alt="ValoRex" className="w-12 h-12 object-contain" fallbackClassName="w-12 h-12" />
            </div>
            <h1 className="font-mono-display text-2xl text-white">Access Terminal</h1>
            <p className="text-sm text-zinc-400">Sign in to your ValoRex vault</p>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            {error && (
              <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded p-2">{error}</div>
            )}
            <label className="block">
              <span className="text-xs uppercase tracking-widest text-cyan-300">Email</span>
              <div className="mt-1 flex items-center gap-2 bg-black/40 border border-zinc-800 focus-within:border-orange-400/70 rounded px-3 py-2">
                <Mail className="w-4 h-4 text-zinc-500"/>
                <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="operator@valorex.com" className="bg-transparent flex-1 outline-none text-white placeholder:text-zinc-600"/>
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest text-cyan-300">Password</span>
              <div className="mt-1 flex items-center gap-2 bg-black/40 border border-zinc-800 focus-within:border-orange-400/70 rounded px-3 py-2">
                <Lock className="w-4 h-4 text-zinc-500"/>
                <input required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="••••••••" className="bg-transparent flex-1 outline-none text-white placeholder:text-zinc-600"/>
              </div>
            </label>
            <button disabled={loading} className="btn-neon w-full justify-center">
              {loading ? 'Authenticating...' : (<>Login <ArrowRight className="w-4 h-4"/></>)}
            </button>
          </form>
          <div className="mt-6 text-sm text-center text-zinc-400">
            New operator? <Link to="/auth/register" className="text-cyan-300 hover:text-cyan-200">Create an account</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
